export default function Opportunity() {
  return (
    <section id="opportunity" className="py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="w-full h-[520px] rounded-2xl overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/f5c2fbd2-009e-4007-925f-0a8e75ed6c39/9b87512c-2dcf-4012-bf66-883f919bf615_7nEQbgmOI6Lj96sRVkXH2uIuUE0.jpg?v=1633eb090b4d819b1d81e71c033666ce"
                alt="Luxury villa padel court"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-6 shadow-lg w-52">
              <div className="font-cormorant text-4xl font-semibold text-[#D4845C]">400%</div>
              <div className="font-inter text-xs text-[#6B6B6B] mt-1 leading-snug">
                Global padel participation growth since 2019
              </div>
            </div>
            {/* Accent line */}
            <div className="absolute -left-4 top-12 w-1 h-32 bg-[#D4845C] rounded-full" />
          </div>

          {/* Right: Content */}
          <div>
            <p className="font-inter text-xs text-[#D4845C] uppercase tracking-[0.2em] font-medium mb-5">
              The Opportunity
            </p>
            <h2 className="font-cormorant text-5xl lg:text-6xl font-light leading-[1.1] text-[#2C2C2C] mb-8">
              Padel is the World&apos;s<br />
              <em className="italic">Fastest-Growing Sport.</em>
              <br />Your Villa is Ready.
            </h2>
            <p className="font-inter font-light text-[#6B6B6B] text-base leading-relaxed mb-6">
              Over 25 million people now play padel, with numbers doubling every three years. High-net-worth players who travel internationally and spend generously are actively searching for destinations where their passion meets luxury accommodation.
            </p>
            <p className="font-inter font-light text-[#6B6B6B] text-base leading-relaxed mb-10">
              Today, no curated platform exists to connect these guests with the exceptional private-court villas they&apos;re looking for. <strong className="font-medium text-[#2C2C2C]">PadelVillas fills that gap, and founding partners are being accepted right now.</strong>
            </p>

            {/* Stats row */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-100">
              {[
                { val: '25M+', label: 'Active players worldwide' },
                { val: '70+', label: 'Countries with padel courts' },
                { val: '€4.1B', label: 'Padel market by 2030' },
              ].map((s) => (
                <div key={s.label}>
                  <div className="font-cormorant text-3xl font-semibold text-[#2C2C2C]">{s.val}</div>
                  <div className="font-inter text-xs text-[#6B6B6B] mt-1 leading-snug">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
